const EnumLcids = {
    English: 1033,
    French: 3084
};

export default EnumLcids;

